module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event4/younite-event-en-7fb895d4a8989078d995e6952b1ffb19.png";